const __typename = 'SignaturePoints'

const signaturePointsDefaults = {
  signaturePoints: {
    __typename,
    id: null,
    points: null,
    socketId: null,
    width: null,
  },
}

export default function updateSignaturePoints(_, input, { cache }) {
  const { points, socketId, width } = input
  const data = {
    signaturePoints: {
      __typename,
      id: null,
      points,
      socketId,
      width,
    },
  }
  cache.writeData({ data })
  return data
}

export { signaturePointsDefaults }
